import { useCallback } from 'react'
import { HighlightLogo } from '@highlight/ui'
import WorkOsIpcRenderer from '@renderer/ipc/WorkOsIpc.renderer'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import { FrameCta as FormButton } from '@renderer/windows/features/onboarding/components/frame/nested/cta'

/** Post-onboarding signed-out sidepanel body (HIG-5902); CTAs match the onboarding window's login form. */
export function SidepanelSignInGate() {
  const handleSignIn = useCallback(() => {
    try {
      AmplitudeRenderer.trackEvent('Auth', {
        action: 'Sign In',
        source: 'Sidepanel sign-in gate',
        authenticationStep: 'Open login page',
      })
      WorkOsIpcRenderer.showSignIn('sign-in')
    } catch (error) {
      console.error('Failed to open sign in:', error)
    }
  }, [])

  const handleCreateAccount = useCallback(() => {
    try {
      AmplitudeRenderer.trackEvent('Auth', {
        action: 'Sign Up',
        source: 'Sidepanel sign-in gate',
        authenticationStep: 'Open login page',
      })
      WorkOsIpcRenderer.showSignIn('sign-up')
    } catch (error) {
      console.error('Failed to open sign up:', error)
    }
  }, [])

  return (
    <div className="flex w-full grow flex-col items-center justify-center px-4">
      <div className="flex w-full max-w-[350px] flex-col items-center gap-6">
        <HighlightLogo size="sm" className="text-foreground" />

        <div className="flex w-full flex-col gap-3">
          <FormButton className="max-w-[350px]" onClick={handleSignIn}>
            Sign in
          </FormButton>
          <FormButton variant="secondary" className="max-w-[350px]" onClick={handleCreateAccount}>
            Create your account
          </FormButton>
        </div>

        <p className="text-foreground-secondary type-prose-xs text-center">
          By creating your account, you agree to our{' '}
          <a
            href="https://highlightai.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground cursor-pointer underline"
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href="https://highlightai.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground cursor-pointer underline"
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  )
}
